/**
 * Trends page — total score trend by site + monthly subscale trend lines.
 */

import { useDashboardContext } from '@/components/layout/DashboardShell';
import { TrendLineChart } from '@/components/dashboard/TrendLineChart';
import { SubscaleTrendChart } from '@/components/dashboard/SubscaleTrendChart';
import { computeMonthlySubscaleTrends } from '@/lib/dashboard/aggregations';

export function TrendsPage() {
  const { filtered } = useDashboardContext();
  const monthlyData = computeMonthlySubscaleTrends(filtered);

  if (filtered.length === 0) {
    return (
      <div className="mx-auto flex max-w-7xl flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center">
        <p className="text-lg font-medium">No trend data available</p>
        <p className="text-sm text-muted-foreground">Submit observations over time to see trends.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-7xl space-y-6 px-6 py-6">
      <TrendLineChart observations={filtered} />
      <SubscaleTrendChart data={monthlyData} />
    </div>
  );
}
